/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownAssessorType } from '../models/db_DropdownAssessorType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AssessorTypes {
    /**
     * Get a list of assessor types
     * @returns db_DropdownAssessorType OK
     * @throws ApiError
     */
    public static listAssessorTypes(): CancelablePromise<Array<db_DropdownAssessorType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assessor-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
